import React from 'react'
import colors from '../../../utils/colors'

const ShareButtons = () => {
  return (
    <div className="mb-5">
      <p className="text-sm lg:text-xs font-bold mb-5 text-center lg:text-left">Share this resource</p>
      <div className="flex items-center justify-center lg:justify-start -mx-2">
        <div className="w-1/4 lg:w-1/6 px-2">
          <div
            className="rounded border text-primary text-xs text-center px-2 py-1 cursor-pointer"
            style={{borderColor: colors.primary}}
          >
            Copy
          </div>
        </div>
        <div className="w-auto lg:w-1/3 px-2">
          <div className="flex items-center">
            <img className="mr-2 cursor-pointer" src="/images/logos/khub_facebook-logo.svg" alt="facebook"/>
            <img className="mr-2 cursor-pointer" src="/images/logos/khub_twitter.svg" alt="twitter"/>
            <img className="cursor-pointer" src="/images/logos/khub_linkedin.svg" alt="linkedin"/>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ShareButtons }